/**
 * @Time    : 2024/1/18 15:20
 * @Author  : tlovet
 * @Software: WebStorm
 */

import { request } from '@umijs/max';

/** 登陆 */
export async function postAuthLogin(params: {
  data: AUTH.LoginParams;
}): Promise<AUTH.loginResponse> {
  return request('/auth/login', {
    method: 'POST',
    data: params,
  });
}

/** 获取当前登录用户信息 */
export async function getCurrentUser(): Promise<AUTH.CurrentUserResponse> {
  return request('/auth/userinfo', {
    method: 'GET',
    skipErrorHandler: false,
  });
}

/** 登出 */
export async function postAuthLogout(): Promise<APIResponse> {
  return request('/auth/logout', {
    method: 'POST',
    // data: {},
  });
}
